export const PERMISSAO = 
{
    ANALISTA: "É preciso estar ter permissão de analista para gerar documentos! Peça a permissão ao seu gestor.",
    LOGADO: "É preciso estar logado para gerar documentos! Você pode fazer login no botão Entrar na parte superior da página."
}